import { ButtonGroup, fade, IconButton, makeStyles } from '@material-ui/core';
import PieChartIcon from '@material-ui/icons/PieChart';
import BarChartIcon from '@material-ui/icons/BarChart';
import ShowChartIcon from '@material-ui/icons/ShowChart';
import { CHART_TYPES } from '../../redux_store';

const useStyles = makeStyles((theme) => ({
  chartBoxButtons: {
    position: 'absolute',
    right: 28,
    height: 32,
    top: 28,
    zIndex: 1,
    display: 'flex',
    wrap: 'nowrap',
    gap: 16,
  },
  buttonGroup: {
    border: `1px solid ${fade(theme.palette.common.black, 0.12)}`,
    borderRadius: theme.shape.borderRadius,
  },
  date: {
    position: 'relative',
    width: 170,
    padding: '0 8px',
    border: `1px solid ${fade(theme.palette.common.black, 0.12)}`,
    borderRadius: theme.shape.borderRadius,
  },
}));

const ChartButtons = ({ chartType, setCharts, charts, dataKey, chartDate }) => {
  const classes = useStyles();

  const updateCharts = (chartType) => {
    let newCharts = charts.map((chart) => {
      if (chart.key === dataKey) {
        return {
          ...chart,
          chartType: chartType,
        };
      } else {
        return chart;
      }
    });
    setCharts(newCharts);
  };

  const updateChartsDates = (chartDates) => {
    let newCharts = charts.map((chart) => {
      if (chart.key === dataKey) {
        return {
          ...chart,
          chartDate: chartDates,
        };
      } else {
        return chart;
      }
    });
    setCharts(newCharts);
  };

  return <div className={classes.chartBoxButtons}>
    {/*<div className={classes.date}>*/}
    {/*<CalendarPopover*/}
    {/*  width={100}*/}
    {/*  shouldReduceFontSize*/}
    {/*  disabled={false}*/}
    {/*  shouldRange={true}*/}
    {/*  shortView={true}*/}
    {/*  onChange={updateChartsDates}*/}
    {/*  date={chartDate}*/}
    {/*  maxDate={new Date()}*/}
    {/*/>*/}
    {/*</div>*/}
    <ButtonGroup
      className={classes.buttonGroup}
      color='primary'
      aria-label='outlined primary button group'
    >
      {Object.keys(CHART_TYPES).map((_chartType) => {
        const type = _chartType.toLowerCase();
        let icon;
        switch (type) {
          case CHART_TYPES.BAR:
            icon = <BarChartIcon fontSize='inherit' />;
            break;
          case CHART_TYPES.PIE:
            icon = <PieChartIcon fontSize='inherit' />;
            break;
          case CHART_TYPES.LINE:
            icon = <ShowChartIcon fontSize='inherit' />;
            break;
        }
        return (
          <IconButton
            key={type}
            aria-label='delete'
            className={classes.margin}
            size='small'
            color={chartType === type ? 'primary' : 'secondary'}
            onClick={() => updateCharts(type)}
          >
            {icon}
          </IconButton>
        );
      })}
    </ButtonGroup>
  </div>;
};

export default ChartButtons;
